import React from "react";
import OrderTable from "../Table";

const AllOrders = () => {
  return <OrderTable type="All" />;
};

export default AllOrders;
